"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HamburgerMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _reactI18nify = require("react-i18nify");

var _icon = _interopRequireDefault(require("@internet-features/icon"));

var _hamburgerMenuNavigation = _interopRequireDefault(require("./hamburger-menu-navigation"));

require("./hamburger-menu.scss");

var _openAction = _interopRequireDefault(require("./actions/open-action"));

var _closeAction = _interopRequireDefault(require("./actions/close-action"));

var _hideAction = _interopRequireDefault(require("./actions/hide-action"));

var _signOutAction = _interopRequireDefault(require("../actions/sign-out-action"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var HamburgerMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(HamburgerMenu, _React$Component);

  function HamburgerMenu(props) {
    var _this;

    _classCallCheck(this, HamburgerMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HamburgerMenu).call(this, props));
    _this.openMenu = _this.openMenu.bind(_assertThisInitialized(_this));
    _this.closeMenu = _this.closeMenu.bind(_assertThisInitialized(_this));
    _this.animationStart = _this.animationStart.bind(_assertThisInitialized(_this));
    _this.animationEnd = _this.animationEnd.bind(_assertThisInitialized(_this));
    _this.signOut = _this.signOut.bind(_assertThisInitialized(_this));
    _this.animationRunning = false;
    _this.hamburgerRef = _react["default"].createRef();
    _this.hamburgerCloseRef = _react["default"].createRef();
    return _this;
  }

  _createClass(HamburgerMenu, [{
    key: "openMenu",
    value: function openMenu() {
      if (this.animationRunning) {
        return;
      }

      this.props.open();
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      if (this.animationRunning) {
        return;
      }

      this.props.close();
    }
  }, {
    key: "animationStart",
    value: function animationStart() {
      this.animationRunning = true;
    }
  }, {
    key: "animationEnd",
    value: function animationEnd() {
      this.animationRunning = false;

      if (this.props.hamburgerMenuState === "open" && this.hamburgerCloseRef.current) {
        this.hamburgerCloseRef.current.focus();
        return;
      } else if (this.props.hamburgerMenuState === "open") {
        return;
      }

      this.props.hide();

      if (this.hamburgerRef.current) {
        this.hamburgerRef.current.focus();
      }
    }
  }, {
    key: "signOut",
    value: function signOut() {
      this.props.close();
      this.props.signOut();
    } // eslint-disable-next-line max-lines-per-function

  }, {
    key: "render",
    value: function render() {
      var store = this.context.store;
      var disabled = true;
      var logoutDisplay = "d-none";

      if (this.props.isAuthenticated) {
        logoutDisplay = "d-block";
      }

      if (this.props.hamburgerMenuState === "open") {
        disabled = false;
      }

      return _react["default"].createElement(_reactRedux.Provider, {
        store: store
      }, _react["default"].createElement("div", null, _react["default"].createElement("button", {
        className: "hamburger-menu-btn ml-2 b-none overflow-hidden focus-outline-0 hover-color-primary focus-outline-primary cursor-pointer",
        onClick: this.openMenu,
        ref: this.hamburgerRef,
        "aria-label": _reactI18nify.I18n.t("header.menu")
      }, _react["default"].createElement(_icon["default"], {
        name: "ki-menu",
        style: {
          "height": "32px",
          "width": "32px"
        }
      }), _react["default"].createElement("span", {
        className: "ml-2 align-middle d-none d-xl-inline"
      }, _react["default"].createElement(_reactI18nify.Translate, {
        value: "header.menu"
      }))), _react["default"].createElement("div", {
        className: "hamburger-menu ".concat(this.props.hamburgerMenuState),
        onAnimationStart: this.animationStart,
        onAnimationEnd: this.animationEnd
      }, _react["default"].createElement("div", {
        className: "hamburger-background"
      }, _react["default"].createElement(_reactFocusLock["default"], {
        returnFocus: true,
        disabled: disabled
      }, _react["default"].createElement("div", {
        className: "row justify-content-start mb-4"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("button", {
        className: "hamburger-menu-btn ml-3 mt-4 b-none overflow-hidden focus-outline-0 hover-color-primary focus-outline-primary cursor-pointer",
        "aria-label": _reactI18nify.I18n.t("header.closeMenu"),
        onClick: this.closeMenu,
        ref: this.hamburgerCloseRef
      }, _react["default"].createElement(_icon["default"], {
        name: "ki-x",
        style: {
          "height": "32px",
          "width": "32px"
        }
      })))), _react["default"].createElement(_hamburgerMenuNavigation["default"], null), _react["default"].createElement("div", {
        className: "row justify-content-center ".concat(logoutDisplay)
      }, _react["default"].createElement("div", {
        className: "col-8 offset-2 text-center"
      }, _react["default"].createElement("button", {
        type: "button",
        className: "btn btn-block btn-primary focus-border-dark",
        onClick: this.signOut
      }, _react["default"].createElement(_reactI18nify.Translate, {
        value: "signOut"
      })), _react["default"].createElement("p", {
        className: "mt-4"
      })))))), _react["default"].createElement("div", {
        className: "hamburger-menu-overlay bg-dark ".concat(this.props.hamburgerMenuState),
        onClick: this.closeMenu
      })));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        "close": _propTypes["default"].func,
        "hamburgerMenuState": _propTypes["default"].string,
        "hide": _propTypes["default"].func,
        "isAuthenticated": _propTypes["default"].bool,
        "open": _propTypes["default"].func,
        "signOut": _propTypes["default"].func
      };
    }
  }]);

  return HamburgerMenu;
}(_react["default"].Component);

exports.HamburgerMenu = HamburgerMenu;
HamburgerMenu.contextTypes = {
  "store": _propTypes["default"].object.isRequired
};

function mapStateToProps(state) {
  return {
    "hamburgerMenuState": state.hamburgerMenu.hamburgerMenuState,
    "isAuthenticated": state.auth.isAuthenticated
  };
}

function mapDispatchToProps(dispatch) {
  return {
    "close": function close() {
      dispatch((0, _closeAction["default"])());
    },
    "hide": function hide() {
      dispatch((0, _hideAction["default"])());
    },
    "open": function open() {
      dispatch((0, _openAction["default"])());
    },
    "signOut": function signOut() {
      dispatch((0, _signOutAction["default"])());
    }
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HamburgerMenu);

exports["default"] = _default;